import React, { useCallback, useEffect } from 'react';
import { useList } from 'react-use';
import './style.scss';
import Select from 'react-select';

const DropdownIndicator = () => {
  return <img src="/img/ic_arrow_down1.svg" alt="img" />
};

function FilterModal(props) {
  const [filters, filterHelper] = useList([]);
  const [filterData, filterDataHelper] = useList([]);

  useEffect(() => {
    filterDataHelper.set(props.filters);
  }, [])

  useEffect(() => {
    if(!props.selectedFilters) return;
    const list = [];
    props.selectedFilters.forEach((item) => {
      const findData = props.filters.find(filter => filter.column === item.column);
      if(!findData) return;
      list.push({
        ...findData,
        data: item.data,
        selectedValue: item,
      });
    });
    filterHelper.set([...list, {}]);
  }, [props.selectedFilters]);

  const removeFilter = useCallback((index) => {
    // console.log('index', index);
    filterHelper.removeAt(index);
  }, []);

  const addNewFilter = useCallback(() => {
    filterHelper.push({});
  }, []);

  const onSelectFilter = (data, item, index) => {
    filterHelper.updateAt(index, {
      ...data,
      selectedValue: data,
    });
  };

  const onSelectFilterValue = (value, item, index) => {
    filterHelper.updateAt(index, {
      ...item,
      data: value,
    });
  };

  const renderFilter = useCallback((item, index) => {
    if (item.values) {
      return <Select
        value={item.data}
        className='leader-board-select__container'
        classNamePrefix={'leader-board-select'}
        placeholder={item.name}
        options={item.values}
        getOptionValue={option => option.value}
        getOptionLabel={option => option.display}
        components={{
          DropdownIndicator,
        }}
        onChange={(data) => onSelectFilterValue(data, item, index)} />
    }
    if (item.value === 'int') {
      return <input type="number" value={item.data} placeholder={item.name} onChange={(e) => onSelectFilterValue(e.target.value, item, index)} />
    }
    return <input type="text" value='' placeholder={'値'} onChange={(e) => onSelectFilterValue(e.target.value, item, index)} />
  }, []);

  const onSubmit = useCallback(() => {
    const listValid = filters.filter((item) => item.data && item.selectedValue);
    props.onSave(listValid.map((item) => {
      return {
        ...item.selectedValue,
        data: item.data,
      }
    }));
  }, [filters]);

  return (
    <div className="wrap-filter">
      <div className="filter">
        <h4>絞り込み条件</h4>
        <div>
          {filters.map((item, index) => {
            return (
              <div key={index} style={{ 'paddingTop': 10, display: 'flex', alignItems: 'center' }}>
                <Select
                  value={item.selectedValue || null}
                  className='leader-board-select__container'
                  classNamePrefix={'leader-board-select'}
                  placeholder={'シーズン'}
                  options={filterData}
                  getOptionValue={option => option.column}
                  getOptionLabel={option => option.name}
                  components={{
                    DropdownIndicator,
                  }}
                  onChange={(option) => onSelectFilter(option, item, index)} />
                {renderFilter(item, index)}
                <img alt="delete" src="/img/ic_delete2.png" onClick={() => removeFilter(index)} />
              </div>
            )
          })}
        </div>
        <button onClick={addNewFilter}>条件を追加</button>
        <div>
          <button onClick={props.onCloseModal}>キャンセル</button>
          <button onClick={onSubmit}>更新</button>
        </div>
      </div>
    </div>
  )
}

export default FilterModal;